import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const CreateWizardConfigContext = React.createContext();

const CreateWizardConfigContextProvider = ({ createWizardConfig: defaultConfig, children }) => {
  const [createWizardConfig, _setCreateWizardConfig] = useState(defaultConfig);
  useEffect(() => {
    _setCreateWizardConfig(defaultConfig);
  }, [defaultConfig]);

  const setCreateWizardConfig = newCreateWizardConfig => {
    _setCreateWizardConfig(newCreateWizardConfig);
  };

  return (
    <CreateWizardConfigContext.Provider
      value={{
        createWizardConfig,
        setCreateWizardConfig,
      }}
    >
      {children}
    </CreateWizardConfigContext.Provider>
  );
};

CreateWizardConfigContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  createWizardConfig: PropTypes.shape({}),
};

CreateWizardConfigContextProvider.defaultProps = {
  createWizardConfig: {},
};

export { CreateWizardConfigContext, CreateWizardConfigContextProvider };
